<template>
  <div>

    <router-link
      :to="{name: 'setting-user-list'}"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <!-- required required Wajib diisi -->
      <!-- min:x min:3 Minimal x karakter -->
      <!-- max:x max:10 Maksimal x karakter -->
      <!-- email email Format email valid -->
      <!-- numeric numeric Hanya angka -->
      <!-- between:x,y between:1,10 Antara nilai x dan y -->
      <!-- confirmed confirmed:password Cocok dengan field lain -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <!-- Nama Supplier -->
            <b-col
              xl="6"
              md="12"
            >
              <b-form-group
                label="Nama User"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Nama User"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                label="Username"
                label-for="username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required"
                >
                  <b-form-input
                    id="username"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Username"
                    @blur="email = `${username}@printpro.com`"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                label="Jabatan"
                label-for="jabatan"
              >
                <validation-provider
                  #default="{ errors }"
                  name="jabatan"
                  rules="required"
                >
                  <v-select
                    v-model="role"
                    :options="roleOpt"
                    hint="Pilih Jabatan"
                    label="title"
                    persistent-hint
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              xl="6"
              md="12"
            >
              <b-form-group
                label="Email"
                label-for="email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required"
                >
                  <b-form-input
                    v-model="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukan Email (boleh dibiarkan default)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                label="Password"
                label-for="password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="password"
                  rules="required"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Buat Password"
                    type="password"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="Ulangi Password"
                label-for="re_password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password Confirmation"
                  rules="required"
                >
                  <b-form-input
                    id="re_password"
                    v-model="re_password"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Ulangi Password"
                    type="password"
                    @blur="passwordCheck"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- Tombol Aksi -->
            <b-col
              md="12"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>

  </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BRow, BCol, BButton, BCard, BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
// eslint-disable-next-line import/no-cycle
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BRow,
    BForm,
    BCol,
    BButton,
    BCard,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id: null,
      name: null,
      username: null,
      email: null,
      role: null,
      roleOpt: [],
      password: null,
      re_password: null,
      passwordMatch: false,
      required,
    }
  },
  computed: {},
  created() {
    const userId = this.$route.params.id

    this.$http.get('/role')
      .then(res => {
        this.roleOpt = res.data.data.map(role => ({
          value: role.id,
          title: role.name,
        }))
      })

    this.$http.get(`/user/${userId}`)
      .then(res => {
        const userData = res.data.data
        this.id = userData.id
        this.name = userData.name
        this.username = userData.username
        this.email = userData.email
        this.role = {
          value: userData.roles ? userData.roles.id : null,
          title: userData.roles ? userData.roles.name : 'Tidak Ada',
        }
      })
      .catch(err => {
        console.error(err)
        this.$bvToast.toast('Gagal mengambil data User.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      })
  },
  mounted() {
  },
  methods: {
    submitUser() {
      const payload = {
        id: this.id,
        name: this.name,
        username: this.username,
        role: this.role.value,
        email: this.email,
        password: this.password,
        password_confirmation: this.re_password,
      }

      this.$http.put(`/user/update/${this.id}`, payload)
        .then(() => {
          this.$bvToast.toast('User berhasil diupdate!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'setting-user-list' })
        })
        .catch(err => {
          const message = err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Gagal menyimpan data User.'

          console.error(err)

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitUser()
        } else {
          this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        }
      })
    },
    passwordCheck() {
      if (this.password !== this.re_password) {
        this.$bvToast.toast('Password tidak cocok!', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
        this.re_password = null
        this.passwordMatch = false
      } else {
        this.passwordMatch = true
      }
    },
  },
}
</script>
